var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgThumbsDown = function SvgThumbsDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "thumbs-down_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 24 24"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".thumbs-down_svg__st0{fill:none;stroke:#4a4a4a;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 5.9c0-1.1-.9-2-2-2-1.7 0-3 1.3-3 3v4c0 1.7 1.3 3 3 3 1.1 0 2-.9 2-2zM8.4 17.1c-.2 1-.1 2 .4 2.9.1.1.1.2.3.4.1.1.1.2.2.2.4.4 1 .5 1.4.1l.2-.2L15 16c1-1.1 1.5-1.6 1.7-2.3.3-.7.3-1.5.3-2.9v-1c0-2.8 0-4.2-.9-5-.9-.9-2.3-.9-5.2-.9h-.5c-2.4 0-3.5 0-4.5.5l-.2.2c-.9.7-1.4 1.7-2.4 3.8-1.1 2.3-1.6 3.4-1.1 4.3.1.1.1.2.2.3.6.8 1.9.8 4.5.8h.4c.8 0 1.1 0 1.4.2.1 0 .3.2.3.4.1.3 0 .6-.2 1.3l-.3.9c0 .2-.1.4-.1.5",
    className: "thumbs-down_svg__st0"
  })));
};
export default SvgThumbsDown;